import { useMobile } from "@cpj-ai/panel-npm-package";
import { Button, Card, useDisclosure } from "@heroui/react";
import { TimesModal } from "./TimesModal/index";

const AvailableTimesModal = () => {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();
  const isMobile = useMobile();

  return (
    <>
      <TimesModal isOpen={isOpen} onClose={onClose} onOpenChange={onOpenChange} />
      <Card className="w-full flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 p-4 shadow-none border-1 border-gray-200 rounded-lg">
        <p className=" text-gray-800 flex flex-col gap-2">
          <span className="font-semibold">Available Interview Times</span>
          <span className="text-gray-500">
            Set and manage the time slots when candidates can schedule interviews for this position
          </span>
        </p>
        <Button color="success" onPress={onOpen} fullWidth={isMobile ? true : false}>
          <span className="text-white">View Interview Times</span>
        </Button>
      </Card>
    </>
  );
};

export default AvailableTimesModal;
